<template>
  <div>
    <div class="catalog__city" v-if="step == 1">
      <div class="catalog__close" @click="clearStartLocation()"></div>
      <div class="catalog__city-title">Место начала аренды</div>
      <div class="catalog__city-field">
        <input type="text" v-model="locationField">
        <div class="catalog__close" @click="clearStartField"></div>
      </div>
      <div class="catalog__city-list">
        <div v-if="locationsStart.length > 0">
          <div class="catalog__city-item" v-for="location in locationsStart" v-bind:key="location.id" @click="setStartLocation(location)">
            <div class="catalog__city-icon" v-if="location.type_id == 1"><img src="@/assets/img/icons/airplane.svg" alt=""></div>
            <div class="catalog__city-icon" v-else><img src="@/assets/img/icons/mark-gray.svg" alt=""></div>
            <div class="catalog__city-name">
              {{location.city_name_ru}}, <span>{{location.name_ru}}</span>
              <div class="catalog__city-sub" v-if="location.cost > 0">
                <div class="catalog__city-sub_title">Аэропортный сбор</div>
                <div class="catalog__city-sub_price">{{location.cost}} <i class="rouble-sign">₽</i></div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <p class="pt-3">Локаций не найдено</p>
        </div>
      </div>
    </div>
    <div class="catalog__city" v-else>
      <div class="catalog__close" @click="clearEndLocation()"></div>
      <div class="catalog__city-title">Место окончания аренды</div>
      <div class="catalog__city-field">
        <input type="text" v-model="locationFieldEnd">
        <div class="catalog__close" @click="clearEndField"></div>
      </div>
      <div class="catalog__city-list">
        <div v-if="locationsEnd.length > 0">
          <div class="catalog__city-item" v-for="location in locationsEnd" v-bind:key="location.id" @click="setEndLocation(location)">
            <div class="catalog__city-icon"><img src="@/assets/img/icons/train.svg" alt=""></div>
            <div class="catalog__city-name">
              {{location.city_name_ru}}, <span>{{location.name_ru}}</span>
              <div class="catalog__city-sub" v-if="location.cost > 0">
                <div class="catalog__city-sub_title">Аэропортный сбор</div>
                <div class="catalog__city-sub_price">{{location.cost}} <i class="rouble-sign">₽</i></div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <p class="pt-3">Локаций не найдено</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'LocationScreenMob',
    data() {
      return {
        locationField: '',
        locationFieldEnd: '',
        locationStartSuccess: false,
      }
    },
    props: ['step'],
    computed: {
      locationsStart() {
        let result = this.$store.getters.locationsStart.filter(location => location.long_name_ru.toLowerCase().includes(this.locationField.toLowerCase()));
        if (result.length == 1) {
          return this.$store.getters.locationsStart;
        } else {
          return result;
        }
      },
      locationsEnd() {
        let result = this.$store.getters.locationsEnd.filter(location => location.long_name_ru.toLowerCase().includes(this.locationFieldEnd.toLowerCase()));
        if (result.length == 1) {
          return this.$store.getters.locationsEnd;
        } else {
          return result;
        }
      },
      isLocationChange() {
        return this.$store.getters.isLocationChange;
      },
      locationStart() {
        return this.$store.getters.locationStart;
      },
      locationEnd() {
        return this.$store.getters.locationEnd;
      },
      parameters() {
        return this.$store.getters.parameters;
      },
    },
    methods: {
      async setStartLocation(location) {
        this.clearVendor();
        await this.$store.dispatch('setLocationStart', location).then(() => {
          this.locationStartSuccess = true;
          this.$store.dispatch('setLocationStart', location).then(() => {
            this.$store.dispatch('setLocationEnd', location).then(() => {
              this.$store.dispatch('getLocationsEnd');
              this.$router.push({ query: Object.assign({}, this.$route.query, {
                pick_up_location_id: this.parameters.pick_up_location_id,
                drop_off_location_id: this.parameters.drop_off_location_id,
              })});
              this.$store.dispatch('setLocationEnd', location).then(() => {
                this.$store.dispatch('getCars');
                this.setLocationChange(false);
              })
            });
          });
        })
      },
      clearVendor() {
        this.$store.dispatch('clearVendor');
        let query = Object.assign({}, this.$route.query);
        delete query.vendor_id;
        this.$router.replace({ query });
      },
      setEndLocation(location) {
        this.clearVendor();
        this.$store.dispatch('setLocationEnd', location).then(() => {
          this.$store.dispatch('getCars');
          this.$router.push({ query: Object.assign({}, this.$route.query, {
            pick_up_location_id: this.parameters.pick_up_location_id,
            drop_off_location_id: this.parameters.drop_off_location_id,
          })});
          this.setLocationChange(false);
        })
      },
      clearStartField() {
        this.locationField = '';
      },
      clearEndField() {
        this.locationFieldEnd = '';
      },
      clearStartLocation() {
        this.setLocationChange(false);
      },
      clearEndLocation() {
        this.setLocationChange(false);
      },
      setLocationChange(status) {
        this.locationStartSuccess = false;
        this.$store.dispatch('setLocationChange', status);
      },
    },
    mounted() {
      this.$store.dispatch('getLocationsStart');
      this.$store.dispatch('getLocationsEnd');
      this.locationField = this.locationStart.long_name_ru;
      this.locationFieldEnd = this.locationEnd.long_name_ru;
    },
    watch: {
      locationStart(value) {
        this.locationField = value.long_name_ru;
      }
    },
}
</script>

<style>
  .catalog__city-field {
    position: relative;
  }
  .catalog__city-field input {
    padding-right: 20px;
  }
  .catalog__city-field .catalog__close {
    right: 0;
    top: 17px;
    opacity: 0.6;
  }
  .catalog__close {
    width: 28px;
    height: 28px;
    background-size: 12px;
    background-position: 50%;
    margin-top: -8px;
    margin-right: -8px;
  }
  .rent-form__part--small span {
    padding-top: 0 !important;
  }
</style>